import * as React from 'react'

/**
 * Cloudflare Email Address Obfuscation rewrites mailto:/emails in HTML and
 * injects `/cdn-cgi/scripts/.../email-decode.min.js`. That breaks CSP
 * (`strict-dynamic` + nonce) and causes React hydration error #418.
 * These HTML comments tell Cloudflare to leave the enclosed markup alone.
 * @see https://developers.cloudflare.com/waf/tools/scrape-shield/email-address-obfuscation/
 */
function CloudflareEmailOff({ children }: { children: React.ReactNode }) {
	return (
		<>
			<span
				aria-hidden="true"
				dangerouslySetInnerHTML={{ __html: '<!--email_off-->' }}
			/>
			{children}
			<span
				aria-hidden="true"
				dangerouslySetInnerHTML={{ __html: '<!--/email_off-->' }}
			/>
		</>
	)
}

export { CloudflareEmailOff }
